export default __webpack_public_path__ + "static/spray-edge-3-d38bc312f9980f87a33ef87c7f9e50ea.png";